import { FORMAT_KINDS, formatKindLabel } from './linkedinCalendar';
import type { FormatKind } from './linkedinCalendar';
import './linkedinCalendar.css';

/**
 * The LinkedIn Calendar's format dot, and the legend that explains it.
 *
 * Same size and ring as the main Calendar's platform dot, so it reads as the
 * same kind of mark. The colour comes from linkedinCalendar.css by
 * data-format, from tokens only. Colour is never the only clue: the pill
 * still shows the typed word, the dot carries its name for screen readers,
 * and the legend pairs every colour with a word.
 */
export function FormatDot({ kind, detail = '' }: { kind: FormatKind; detail?: string }) {
  const label = formatKindLabel(kind);
  return (
    <span
      className="format-dot"
      data-format={kind}
      role="img"
      aria-label={`Format: ${label}`}
      title={detail === '' ? label : `${label} (${detail})`}
    />
  );
}

export function FormatLegend() {
  return (
    <ul className="format-legend" aria-label="Format colours">
      {FORMAT_KINDS.map((entry) => (
        <li key={entry.kind}>
          {/* The word beside it says the same thing, so the dot is hidden from
              screen readers here rather than read twice. */}
          <span className="format-dot" data-format={entry.kind} aria-hidden="true" />
          {entry.label}
        </li>
      ))}
    </ul>
  );
}
